
import { footer } from '../../customWhiteLabel'

export default {
  name: 'BannerInfo',
  data() {
    return {
      footer,
    }
  },
  methods: {
    renovarCertificado() {
      const whatsappUrl = `https://wa.me/${this.footer.botaoRenocao
        }?text=${encodeURIComponent(this.footer.messageRenovacao)}`
      window.open(whatsappUrl, '_blanck')
    },
  },
}
